import { ListIcon, SpadeIcon } from '@repo/icons';
import { memoize } from 'lodash-es';
import type { GameCategoryResponseType } from '@/lib/fetch';
import { type TranslationType } from '@/lib/types';
import { getCasinoCategoryIcon } from '@/lib/utils/casino-categories';

export interface GamesCategoryItem {
  href: string;
  name: string;
  count?: number;
  matches: string[];
  notMatches?: string[];
  code?: string;
  Icon: React.FC<{ className?: string }>;
}

export type CategoryIcon = React.FC<{ className?: string }>;

export interface IconsMap {
  lobby: CategoryIcon;
  'all-games': CategoryIcon;
  // Add more category keys if needed
}

export const Icons: IconsMap = {
  lobby: SpadeIcon,
  'all-games': ListIcon,
};

export const getGamesCategoryItems = memoize(
  (t: TranslationType, data: GameCategoryResponseType, _locale: string, staticCategory = 'lobby') => {
    const totalCount = data.reduce((acc, item) => acc + (item.count ?? 0), 0);

    return [
      {
        Icon: Icons[staticCategory as keyof typeof Icons],
        name: t(staticCategory),
        count: totalCount,
        href: `/casino/${staticCategory}`,
        matches: [`/casino/${staticCategory}`],
        code: staticCategory,
      },
      ...data.map((item) => ({
        Icon: getCasinoCategoryIcon(item.code),
        name: t(`categories.${item.code}`),
        count: item.count ?? 0,
        href: `/casino/${item.code}`,
        matches: [`/casino/${item.code}`],
        code: item.code,
      })),
    ] as GamesCategoryItem[];
  },
  (_t, data, locale, staticCategory) => JSON.stringify({ data, locale, staticCategory })
);
